import fmt from './fmt'

/**
 * 计算两个日期的天数差
 * @param sDate1
 * @param sDate2
 */
export default (sDate1, sDate2) => { // sDate1和sDate2是2002-12-18格式
  var aDate, oDate1, oDate2, iDays
  if (sDate1 instanceof Date) {
    sDate1 = fmt.dateFormat(sDate1, 'yyyy-MM-dd')
  }
  if (sDate2 instanceof Date) {
    sDate2 = fmt.dateFormat(sDate2, 'yyyy-MM-dd')
  }
  aDate = sDate1.split('-')
  oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) // 转换为12-18-2002格式
  aDate = sDate2.split('-')
  oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
  iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
  return iDays
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/dateDiff.js